import { Navigate, useLocation } from "react-router-dom";

export default function PersonInteractionsPage() {
  const location = useLocation();

  return <Navigate to={`${location.pathname}/interactions`} replace />;
}
